import {
    getLoginData,
    getSiteStructure,
    TrackingFilter,
    TRACKING_PLATFORM_TYPE_RESPONSIVE,
    TRACKING_SITE_AREA_MOBILITY,
} from '@vfde-sails/tracking';
import { TRACKING_PAGENAME } from 'Constant';
import { StateProps } from '../interfaces/state';
import {
    TrackingFlowType,
    TrackingPageType,
    TrackingLoginStatus,
    TrackingFacet,
    PageViewTrackingData,
    TrackingTargetAudience,
    TrackingBtx,
} from '@vfde-sails/tracking';

/**
 * Creates the pageview tracking data object,
 * which is passed to the tracking middleware
 */
export const createPageViewTrackingData = (
    trackPageViewParams: {
        selectedCategories: StateProps['selectedCategories'];
    },
): PageViewTrackingData => {
    const { selectedCategories } = trackPageViewParams;
    const trackPageViewData: PageViewTrackingData = {
        /* eslint-disable camelcase, @typescript-eslint/naming-convention, jsdoc/require-jsdoc */
        line_of_customer: TrackingTargetAudience.Consumer,
        business_transaction_type: TrackingBtx.Iot,
        flow_type: TrackingFlowType.IotDevice,
        page_type: TrackingPageType.ProductListing,
        site_area: TRACKING_SITE_AREA_MOBILITY,
        platform_type: TRACKING_PLATFORM_TYPE_RESPONSIVE,
        login_status: getLoginData() ? TrackingLoginStatus.LoggedIn : TrackingLoginStatus.NotLoggedIn,
        page_levels: getSiteStructure(TRACKING_PAGENAME),
        appliedFilters: selectedCategories.map(category => createTrackingFilterObject(category.label)),
        /* eslint-enable */
    };

    return trackPageViewData;
};

/**
 * Creates the filter object for tracking based on the given value
 */
export const createTrackingFilterObject = (value: string): TrackingFilter => ({
    facet: TrackingFacet.Vendor,
    value,
});
